<template>
    <div>
        <div class="page">
            <div class="page_header">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>威有动静</el-breadcrumb-item>
                    <el-breadcrumb-item>分类</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="page_headerSecondary">
                <div></div>
                <div>
                    <!-- <button @click="openDialog('添加')">添加分类</button> -->
                    <VyAddBtn @click.native="openDialog('添加')" />
                </div>
            </div>
            <!-- 列表 -->
            <div class="page_content">
                <el-table :data="tableData" border>
                    <el-table-column prop="name" align="center" label="分类名"> </el-table-column>
                    <el-table-column prop="sort" align="center" label="排序"> </el-table-column>
                    <el-table-column prop="status" align="center" label="状态">
                        <template slot-scope="{ row }">
                            <span :style="{ color: row.status ? '#d66bff' : '#fe7c96' }">{{ row.status ? "显示" : "隐藏" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_top" align="center" label="置顶">
                        <template slot-scope="{ row }">
                            <span>{{ row.is_top ? "是" : "否" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" align="center" label="操作">
                        <template slot-scope="{ row }">
                            <div class="btns">
                                <div class="_operate">
                                    <button @click="openDialog('编辑', row)">编辑</button>
                                </div>
                                <div class="_delete">
                                    <button @click="del(row)">删除</button>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 添加或编辑分类弹框 -->
        <el-dialog :title="txt + '分类'" :visible.sync="dialogShow" width="60%" :show-close="false" :before-close="bfc">
            <el-form :model="form" label-width="80px">
                <el-form-item label="名称">
                    <el-input v-model.trim="form.name"></el-input>
                </el-form-item>
                <el-form-item label="分类描述">
                    <el-input v-model.trim="form.describe"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="form.sort" :min="1" :max="10" label="排序"></el-input-number>
                </el-form-item>
                <el-form-item label="置顶">
                    <el-switch
                        class="sw"
                        v-model="form.is_top"
                        active-color="#7781f1"
                        active-text="是"
                        inactive-text="否"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="状态">
                    <el-switch
                        class="sw"
                        v-model="form.status"
                        active-color="#7781f1"
                        active-text="显示"
                        inactive-text="隐藏"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="广告图">
                    <upImg :src="form.image" @removeSrc="form.image = ''" ref="image"></upImg>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogShow = false">取 消</el-button>
                <el-button type="primary" @click="yes">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import upImg from "../../../customs/uploadImg.vue";
import VyAddBtn from "@/components/customs/VyAddBtn.vue";

export default {
    components: { upImg, VyAddBtn },
    data() {
        return {
            tableData: [],
            dialogShow: false,
            txt: "",
            form: {
                name: "",
                describe: "",
                sort: 1,
                is_top: false,
                status: true,
                image: "",
            },
        };
    },
    async created() {
        this.tableData = await this.getData();
    },
    methods: {
        async getData() {
            let { data } = await axios.get("/api/article/categoryshow");
            return data;
        },
        openDialog(txt, row) {
            this.txt = txt;
            this.dialogShow = true;
            if (row) {
                this.form = { ...row, is_top: Boolean(row.is_top), status: Boolean(row.status) };
            } else {
                this.form = { name: "", describe: "", sort: 1, is_top: false, status: true };
            }
        },
        // 添加或编辑
        async yes() {
            let f = qs.stringify({
                ...this.form,
                is_top: Number(this.form.is_top),
                status: Number(this.form.status),
                image: this.$refs.image.url,
            });
            if (this.txt == "添加") {
                var { data } = await axios.post("/api/article/categoryadd", f);
            } else if (this.txt == "编辑") {
                var { data } = await axios.put("/api/article/categoryupdate", f);
            }
            if (data.code !== 200) {
                this.$message.error(data.msg);
            } else {
                this.$message.success(data.msg);
            }
            this.dialogShow = false;
            this.tableData = await this.getData();
        },
        // 删除
        async del({ id }) {
            let s = await this.$confirm("是否确认删除?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => true)
                .catch(() => false);
            if (!s) return;
            let { data } = await axios.delete("/api/article/categorydel", { params: { id } });
            if (data.code != 200) {
                this.$message.error(data.msg);
            } else {
                this.$message.success(data.msg);
            }
            this.tableData = await this.getData();
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    .page_headerSecondary {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .page_content {
        margin-top: 20px;
        .el-table {
            border-radius: 20px;
        }
        .btns {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }
    }
}
.sw {
    /deep/.is-active {
        color: #7781f1 !important;
    }
}
</style>
